import { render, staticRenderFns } from "./recruitmentManage.vue?vue&type=template&id=2feb68b6&scoped=true&"
import script from "./recruitmentManage.vue?vue&type=script&lang=js&"
export * from "./recruitmentManage.vue?vue&type=script&lang=js&"
import style0 from "./recruitmentManage.vue?vue&type=style&index=0&id=2feb68b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb68b6",
  null
  
)

export default component.exports